import React from "react"
import { logUserEvent } from "../common/firebase.utils"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { showPaymentPopup } from "../store/slices/layerSlice"
import { PRODUCT_OPTIONS } from "../common/constants"
import MembershipBadge from "../common/MembershipBadge"

type MembershipBarProps = {
  userId: string | null
  membershipFrom?: string | null
  membershipType?: string | null
  className?: string
}

export default function MembershipBar({
  userId,
  membershipFrom,
  membershipType,
  className = ""
}: MembershipBarProps) {
  const isMembership = membershipFrom != null
  const dispatch = useDispatch()

  const onClickJoin = () => {
    if (isMembership) {
      return
    }

    if (!userId) {
      alert("로그인이 필요합니다.")
      return
    }

    logUserEvent("click_join_on_mypage")
    dispatch(showPaymentPopup())
  }

  return (
    <Container
      className={`font-medium text-white flex items-center ${
        isMembership ? "py-2 px-3 rounded-full" : "p-3"
      }  ${className}`}
    >
      {isMembership && (
        <MembershipBadge membershipType={membershipType} className="mr-1" />
      )}
      {isMembership ? (
        <p className="font-bold text-xs flex-1">
          {PRODUCT_OPTIONS.find(p => p.id === membershipType)?.title ||
            "뭐라고할까 멤버십"}
        </p>
      ) : (
        <p className="text-left text-[13px] flex-1">
          1회 결제로 <b>평생 무제한</b> 이용!
        </p>
      )}
      <span
        className={`${
          isMembership
            ? "text-[10px]"
            : "text-xs underline cursor-pointer hover:font-bold"
        }`}
        onClick={onClickJoin}
      >
        {isMembership ? `${membershipFrom} 가입` : "멤버십 가입"}
      </span>
    </Container>
  )
}

const Container = styled.div`
  background: linear-gradient(
    290deg,
    #7869d6 -15.93%,
    #3d3764 14.76%,
    #16122c 45.45%
  );
`
